import * as React from "react";
import { Tabs } from "antd";
import { Helmet } from "react-helmet-async";
import AllAssetSummaryReport from "../All Categories Summary Report/AllCategoriesSummaryReport";
import BranchesAllAssetSummaryReport from "../BranchesAllAssetSummaryReport/BranchesAllAssetSummaryReport";
import AllAssetTypesSummaryReport from "../Asset Types Summary Report/AssetTypesSummaryReport";
export default function SummaryReport() {
  const items = [
    {
      key: "1",
      label: "Asset Classification Report",
      children: <AllAssetTypesSummaryReport />,
    },
    {
      key: "2",
      label: "Categories Summary Report",
      children: <AllAssetSummaryReport />,
    },
    {
      key: "3",
      label: "Locations Summary Report",
      children: <BranchesAllAssetSummaryReport />,
    },
  ];

  return (
    <div>
      <Helmet>
        <title>All Assets Summary Report | Assets Register</title>
      </Helmet>
      <Tabs items={items} defaultActiveKey='1' type='card' />
    </div>
  );
}
